module.exports = __webpack_public_path__ + "img/gallery.a1efd3f5.svg";